import gql from 'graphql-tag';

const validShipAreaByOrder = gql`
  query validShipAreaByOrder(
    $order: OrderCreateInput!
  ) {
    validShipAreaByOrder(
      input: $order
    ) {
      result
    }
  }
`;

export default validShipAreaByOrder;
